<template>
  <FilterToggle
    :is-disabled="isDisabled"
    :label="`My ${documentTypeLabel}`"
    :model-value="myJobsEnabled"
    @update:model-value="handleMyJobs"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useFilters } from '@/stores/filters/filters';
import { computed } from 'vue';
import FilterToggle from '@/components/filter/filterMenu/FilterToggle.vue';

defineProps({
  isDisabled: { type: Boolean, default: false },
});

const emits = defineEmits(['filters-tracking-event']);

// Router
const router = useRouter();
const route = useRoute();

// Stores
const filtersStore = useFilters();
const { myJobsEnabled } = storeToRefs(filtersStore);
const { submitMyJobs } = filtersStore;

const documentTypeLabel = computed(() => ({ templates: 'Templates' }[route.name] || 'Jobs'));

const handleMyJobs = ($event) => {
  emits('filters-tracking-event', {
    action: 'filterMyJobsClick',
    args: {
      enable: $event,
      page: route.name,
    },
  });

  // New Events in testing
  emits('filters-tracking-event', {
    action: 'appliedFilters',
    args: {
      page: route.name,
      filterTypes: ['My Jobs'],
      filterName: $event,
    },
  });

  submitMyJobs({ myJobsEnabled: $event, router });
};
</script>
